import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-info',
  templateUrl: './block-info.component.html',
  styleUrls: ['./block-info.component.scss']
})
export class BlockInfoComponent implements OnInit {
activeTab1 = 1;

  constructor() { 



}
ngOnInit(): void {
}
}